export default "/themes/nutristopa/assets/img/water.png";